import { useCallback, useEffect, useState } from 'react';
import * as apiObject from 'api/apiObjects';
import type { ExpendTeamInfoData } from './types';

export const useExpendTeamInfo = (objectId: number | undefined, show: number | false) => {
    const [data, setData] = useState<ExpendTeamInfoData | null>(null);
    const [activeTab, setActiveTab] = useState<'general' | 'workers'>('general');

    const reload = useCallback(async () => {
        if (!objectId || !show) return;
        const res = await apiObject.getObjectExpendTeam(objectId, show);
        setData(res || null);
    }, [objectId, show]);

    useEffect(() => {
        if (show) {
            setActiveTab('general');
            void reload();
            return;
        }
        const timer = setTimeout(() => {
            setData(null);
            setActiveTab('general');
        }, 300);
        return () => clearTimeout(timer);
    }, [show, reload]);

    return { data, reload, activeTab, setActiveTab };
};
